import wrapper from '../analytics-wrapper';

export default {
  clickAppStoreLink(platform, context) {
    wrapper.track('Clicked app store link', {
      Platform: platform,
      Context: context, // e.g., 'DownloadTemperatureRequiresApp',
    });
  },
};
